import React, { useContext } from 'react';
import moment from 'moment';
import DiscoveryContext from '../../../../contexts/discoveryContext/contextV2';
import TileSet from '../../../../shared/TileSet';
import ImageTile from '../../../../shared/Tiles/ImageTile';
import { container } from './styles.module.css';
import { withTracking } from '../../provider';

const TimeGroupings = [
  {
    label: 'This Weekend',
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/c_scale,f_auto,w_400/v1/category-assets/tile-images/this-weekend.png',
    start: moment()
      .isoWeekday(6)
      .startOf('day'),
    end: moment()
      .isoWeekday(7)
      .endOf('day'),
  },
  {
    label: 'Next Weekend',
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/c_scale,f_auto,w_400/v1/category-assets/tile-images/next-weekend.png',
    start: moment()
      .add(1, 'week')
      .isoWeekday(6)
      .startOf('day'),
    end: moment()
      .add(1, 'week')
      .isoWeekday(7)
      .endOf('day'),
  },
  {
    label: 'This Summer',
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/c_scale,f_auto,w_400/v1/category-assets/tile-images/this-summer.png',
    start: moment('2020-06-01').startOf('day'),
    end: moment('2020-09-30').endOf('day'),
  },
  {
    label: 'This Autumn',
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/c_scale,f_auto,w_400/v1/category-assets/tile-images/this-autumn.png',
    start: moment('2020-09-30').endOf('day'),
    end: moment('2020-11-30').startOf('day'),
  },
  {
    label: 'This Winter',
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/c_scale,f_auto,w_400/v1/category-assets/tile-images/this-winter.png',
    start: moment('2020-11-30').startOf('day'),
    end: moment('2021-03-01').endOf('day'),
  },
];

const TimingEventsSlice = ({
  injected: {
    tracking: { trackButtonClick },
  },
}) => {
  const {
    getLinkWithFilters,
    activeFilters: { date: activeDateFilter },
  } = useContext(DiscoveryContext);

  if (activeDateFilter) {
    return null;
  }

  const availableGroups = TimeGroupings.filter(
    (group) => group.end >= moment(),
  );

  const tiles = availableGroups.map((group) => (
    <ImageTile
      title={group.label}
      link={
        getLinkWithFilters({
          minDate: group.start.toISOString(),
          maxDate: group.end.toISOString(),
        }).url
      }
      key={group.label}
      image={group.image}
      onClick={() =>
        trackButtonClick('tile', {
          label: group.label,
          minDate: group.start.toISOString(),
          maxDate: group.end.toISOString(),
        })
      }
    />
  ));

  return (
    <div className={container}>
      <TileSet>{tiles}</TileSet>
    </div>
  );
};

export default withTracking('timing_slice')(TimingEventsSlice);
